import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_SUPPLIER,
  CLEAR_SUPPLIER_FOOD_TYPE,
  CLEAR_SUPPLIERS,
  FLAG_GETTING_SUPPLIERS,
  FLAG_SUPPLIER_ACTIVITY,
  FLAG_SUPPLIER_FOOD_TYPE_ACTIVITY,
  GET_SUPPLIER,
  GET_SUPPLIER_FOOD_TYPE,
  GET_SUPPLIERS,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  foodType: Immutable.Map({
    content: Immutable.List(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_SUPPLIERS:
      return state.setIn(['all', 'loading'], payload);

    case GET_SUPPLIERS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));

    case CLEAR_SUPPLIERS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );

    case FLAG_SUPPLIER_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );

    case GET_SUPPLIER:
      return state.setIn(['current', 'content'], Immutable.Map(payload));

    case CLEAR_SUPPLIER:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));

    case FLAG_SUPPLIER_FOOD_TYPE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['foodType', 'activity'],
          state.getIn(['foodType', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['foodType', 'activity'],
        state.getIn(['foodType', 'activity']).pop(),
      );

    case GET_SUPPLIER_FOOD_TYPE:
      return state.setIn(['foodType', 'content'], Immutable.List(payload));

    case CLEAR_SUPPLIER_FOOD_TYPE:
      return state.setIn(['foodType'], INITIAL_STATE.getIn(['foodType']));

    default:
      return state;
  }
};
